import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import {Box, CircularProgress, Paper} from '@mui/material'
import Stack from '@mui/material/Stack'
import {classesIP} from '../selectedPersonaStyles'
import {ReactComponent as UnemploymentIcon} from '../../../../icons/Personas/engagement/Unemployment.svg'
import {ReactComponent as UninsuranceIcon} from '../../../../icons/Personas/engagement/Uninsurance.svg'
import {SuperscriptDagger} from '../../../common/Dagger'
import ZeroPopulationBanner from '../../ZeroPopulationBanner'

const InsuranceEmployment = ({
  engagementData,
  loadingPersonaEngagement,
  isZeroCountPopulation,
  handlePersonaCustomLabel
}) => {
  return (
    <>
      {loadingPersonaEngagement && (
        <CircularProgress className={classesIP.CircularProgress} size={15} title="loading" />
      )}

      <Typography
        className={classesIP.personaSubTitle}
        variant="overline"
        tabIndex={0}
        aria-label={'Engagement Section'}
      >
        {handlePersonaCustomLabel('engagement', 'ENGAGEMENT')}
      </Typography>

      {isZeroCountPopulation && <ZeroPopulationBanner />}

      <Box className={classesIP.Box}>
        <Paper elevation={1} className={classesIP.Paper}>
          <Stack alignItems="center" spacing={{xs: 1, sm: 1}} direction="row" useFlexGap>
            <Stack className={classesIP.overviewKeyChar1Stack} tabIndex={0}>
              <Stack direction="row" className={classesIP.overviewKeyChar1StackChild} spacing={1}>
                <UninsuranceIcon className={classesIP.overviewKeyChar1Icon} />
                <Typography className={classesIP.engagementPercent} variant="overline">
                  {engagementData.uninsuranceRisk + '%'}
                  {isZeroCountPopulation && <SuperscriptDagger width={10} height={10} />}
                </Typography>
              </Stack>
              <Typography className={classesIP.engagementText} align="center">
                {handlePersonaCustomLabel('engagement', 'Uninsurance')}{' '}
              </Typography>
              <Typography className={classesIP.engagementDetail} variant="body2" align="center">
                Percentage of individuals with high{' '}
                {handlePersonaCustomLabel('engagement', 'Uninsurance').toLowerCase()} risk
              </Typography>
            </Stack>

            <Stack className={classesIP.overviewKeyChar1Stack} tabIndex={0}>
              <Stack direction="row" className={classesIP.overviewKeyChar1StackChild} spacing={1}>
                <UnemploymentIcon className={classesIP.overviewKeyChar1Icon} />
                <Typography className={classesIP.engagementPercent} variant="overline">
                  {engagementData.unemploymentRisk + '%'}
                  {isZeroCountPopulation && <SuperscriptDagger width={10} height={10} />}
                </Typography>
              </Stack>
              <Typography className={classesIP.engagementText} align="center">
                {handlePersonaCustomLabel('engagement', 'Unemployment')}{' '}
              </Typography>
              <Typography className={classesIP.engagementDetail} variant="body2" align="center">
                Percentage of individuals with high{' '}
                {handlePersonaCustomLabel('engagement', 'Unemployment').toLowerCase()} risk
              </Typography>
            </Stack>
          </Stack>
        </Paper>
      </Box>
    </>
  )
}

InsuranceEmployment.propTypes = {
  engagementData: PropTypes.shape({
    uninsuranceRisk: PropTypes.number,
    unemploymentRisk: PropTypes.number,
    hospitalAccess: PropTypes.number,
    pharmacyAccess: PropTypes.number,
    transportationInsecurity: PropTypes.number
  }),
  loadingPersonaEngagement: PropTypes.bool.isRequired,
  isZeroCountPopulation: PropTypes.bool.isRequired,
  handlePersonaCustomLabel: PropTypes.func.isRequired
}

export default InsuranceEmployment
